:host{
    height: 100%;
}
:host(:focus), :host(:focus-visible){
    outline: none;
}
.bank-indicator-web-component{
    height: 100%;
    aspect-ratio: 1 / 1;
    --jb-input-box-indicator-padding: var(--bank-indicator-padding,8px 16px);
    .bank-image-wrapper{
        height: 100%;
        width: 100%;
        svg{
            display: block;
            height: 100%;
            max-width: 100%;
            object-fit: contain;
        }
    }
}